// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-record-instructions-dialog__paper {
  background: #0f172a !important;
  color: #f8fafc !important;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px !important;
  min-width: min(360px, 92vw);
}

.lt-record-instructions-dialog__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 1rem;
}

.lt-record-instructions-dialog__label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  opacity: 0.85;
  margin-bottom: 6px;
}

.lt-record-instructions-dialog__select {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(15, 23, 42, 0.95);
  color: #f8fafc;
  font-size: 0.95rem;
  font-weight: 600;
}

.lt-record-instructions-dialog__status {
  margin: 14px 0 0;
  font-size: 0.85rem;
  line-height: 1.4;
  opacity: 0.88;
}

.lt-record-instructions-dialog__status--live {
  color: #f87171;
  font-weight: 700;
  opacity: 1;
}

.lt-record-instructions-dialog__status--error {
  color: #fbbf24;
  font-weight: 600;
  opacity: 1;
}

.lt-record-instructions-dialog__actions {
  padding: 8px 16px 16px !important;
  gap: 8px;
}

.lt-record-instructions-dialog__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
}

.lt-record-instructions-dialog__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lt-record-instructions-dialog__btn--ghost {
  background: transparent;
  color: rgba(248, 250, 252, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.lt-record-instructions-dialog__btn--start {
  background: var(--lt-brand, #0877bc);
  color: #fff;
}

.lt-record-instructions-dialog__btn--stop {
  background: #dc2626;
  color: #fff;
}

.lt-record-instructions-dialog__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.lt-record-instructions-dialog__label-row .lt-record-instructions-dialog__label {
  margin-bottom: 0;
}

.lt-record-instructions-dialog__label-actions {
  display: inline-flex;
  gap: 10px;
}

.lt-record-instructions-dialog__link {
  border: none;
  background: transparent;
  color: #93c5fd;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

.lt-record-instructions-dialog__link:hover {
  text-decoration: underline;
}

.lt-record-instructions-dialog__table-checks {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: min(240px, 40vh);
  overflow: auto;
  padding: 4px 0;
}

.lt-record-instructions-dialog__check {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.6);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
}

.lt-record-instructions-dialog__check--on {
  border-color: rgba(239, 83, 80, 0.55);
  background: rgba(239, 83, 80, 0.12);
}

.lt-record-instructions-dialog__check--live {
  border-color: #dc2626;
  background: rgba(220, 38, 38, 0.18);
  color: #fca5a5;
}

.lt-record-instructions-dialog__check input {
  width: 16px;
  height: 16px;
  accent-color: #ef5350;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingRecordInstructionsDialog.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2CAA2C;EAC3C,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":[".lt-record-instructions-dialog__paper {\n  background: #0f172a !important;\n  color: #f8fafc !important;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px !important;\n  min-width: min(360px, 92vw);\n}\n\n.lt-record-instructions-dialog__title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.lt-record-instructions-dialog__label {\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 600;\n  opacity: 0.85;\n  margin-bottom: 6px;\n}\n\n.lt-record-instructions-dialog__select {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(15, 23, 42, 0.95);\n  color: #f8fafc;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.lt-record-instructions-dialog__status {\n  margin: 14px 0 0;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  opacity: 0.88;\n}\n\n.lt-record-instructions-dialog__status--live {\n  color: #f87171;\n  font-weight: 700;\n  opacity: 1;\n}\n\n.lt-record-instructions-dialog__status--error {\n  color: #fbbf24;\n  font-weight: 600;\n  opacity: 1;\n}\n\n.lt-record-instructions-dialog__actions {\n  padding: 8px 16px 16px !important;\n  gap: 8px;\n}\n\n.lt-record-instructions-dialog__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: none;\n  font-weight: 700;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.lt-record-instructions-dialog__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lt-record-instructions-dialog__btn--ghost {\n  background: transparent;\n  color: rgba(248, 250, 252, 0.85);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.lt-record-instructions-dialog__btn--start {\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n}\n\n.lt-record-instructions-dialog__btn--stop {\n  background: #dc2626;\n  color: #fff;\n}\n\n.lt-record-instructions-dialog__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.lt-record-instructions-dialog__label-row .lt-record-instructions-dialog__label {\n  margin-bottom: 0;\n}\n\n.lt-record-instructions-dialog__label-actions {\n  display: inline-flex;\n  gap: 10px;\n}\n\n.lt-record-instructions-dialog__link {\n  border: none;\n  background: transparent;\n  color: #93c5fd;\n  font-size: 0.75rem;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n}\n\n.lt-record-instructions-dialog__link:hover {\n  text-decoration: underline;\n}\n\n.lt-record-instructions-dialog__table-checks {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: min(240px, 40vh);\n  overflow: auto;\n  padding: 4px 0;\n}\n\n.lt-record-instructions-dialog__check {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.6);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.lt-record-instructions-dialog__check--on {\n  border-color: rgba(239, 83, 80, 0.55);\n  background: rgba(239, 83, 80, 0.12);\n}\n\n.lt-record-instructions-dialog__check--live {\n  border-color: #dc2626;\n  background: rgba(220, 38, 38, 0.18);\n  color: #fca5a5;\n}\n\n.lt-record-instructions-dialog__check input {\n  width: 16px;\n  height: 16px;\n  accent-color: #ef5350;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
